export enum CallStatus {
  NONE = 'none',
  NOTICED = 'noticed',
  ACTIONED = 'actioned',
}

export interface StockCall {
  id: string;
  instrumentName: string;
  instrumentType: string;
  action: string;
  entryPrice: number;
  targetPrice: number;
  exitPrice: string;
  admincomment: string;
  pastComments?: string;
  createdOn: string;
  status: CallStatus;
  trade_type: string;
  source_recommendation_id: string;
  stoploss: string;
 }

export interface Plan {
  plan_id: string;
  plan_name: string;
  description: string;
  price?: number;
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  phone: string;
  plan_id?: string;
  created_at?: string;
  admin?: string;
}

export interface VittaCall {
  call_id: string;
  action: string;
  in_type_id: string;
  entry: string;
  stoploss: string;
  target: string;
  exit?: string;
  created_by?: string;
  created_on: string;
  name: string;
  trade_type: string;
  instrument_type: string;
  admincomment: string;
  pastComments?: string;
}